import React from "react"
import FDR from "../../Assessts/Images/Home/Parterns/FDR.png";

import SSA from "../../Assessts/Images/Home/Parterns/SSA.png";
import Natcotrust from "../../Assessts/Images/Home/Parterns/Natcotrust.png";
import IP from "../../Assessts/Images/Home/Parterns/IP.png";
import GovtAp from "../../Assessts/Images/Home/Parterns/GovtAp.png";
import GovtTS from "../../Assessts/Images/Home/Parterns/GovtTS.png";
import TSWREIS from "../../Assessts/Images/Home/Parterns/TSWREIS.png";
import TSEDUINST from "../../Assessts/Images/Home/Parterns/TSEDUINST.png";
import OAV from "../../Assessts/Images/Home/Parterns/OAV.png";

import OU from "../../Assessts/Images/Home/Parterns/OU.png";
import VNRVJIET from "../../Assessts/Images/Home/Parterns/VNRVJIET.png";
import Assamgovt from "../../Assessts/Images/Home/Parterns/Assam govt.png";
import YDF from "../../Assessts/Images/Home/Parterns/YDF.png";

import KAcademy from "../../Assessts/Images/Home/Parterns/KhanAcademy.png";

import { Row, Col } from "react-bootstrap";

const Patners = () => {
    const Support = [{ img: FDR }];
    const Implementation = [{ img: OAV }, { img: Natcotrust }, { img: GovtAp }, { img: GovtTS }, { img: IP }, { img: TSWREIS }, { img: SSA }, { img: TSEDUINST },]
    const Product = [{ img: OU }, { img: VNRVJIET }, { img: Assamgovt }, { img: YDF }]
    const Knowledge = [{ img: KAcademy },]
    //  const OPenLinkSupported = (index) => {
    //         switch (index) {
    //             case 0: window.open("https://www.ashoka.org/en-us", "_blank");
    //                 break;
    //             case 1: window.open("https://www.agastya.org/", "_blank");
    //                 break;
    //         }
    //     };

    //      const OPenLinkKnowledge = (index) => {
    //         switch (index) {
    //             case 0: window.open("https://www.khanacademy.org/", "_blank");
    //                 break;
    //         }
    //     };

    return (
        <div className="p-4 H-Partners">
            <div className="Web-MainHeading">Our Partners</div>
            <span>Supported By</span>
            <div className="container-fluid Card mb-3" style={{ backgroundColor: "#F6F2ED", width: "fit-content" }}>
                <Row>
                    {Support.map((item, index) => (
                        <Col className=" alignitems Patners-Supported">
                            <div className="CPointer dflex JCCenter" ><img src={item.img} className="w-75" /> </div></Col>
                        // onClick={() => OPenLinkSupported(index)}
                    ))}

                </Row>
            </div>
            <span>Implementation Partners</span>

            <div className="container-fluid Card mb-3 " style={{ backgroundColor: "#F6F2ED", width: "fit-content" }}>
                <Row>
                    {Implementation.map((item) => (
                        <Col className="dflex JCCenter alignitems Patners-Implementation" ><img src={item.img} className="w-100" /> </Col>
                    ))}

                </Row>
            </div>
            <div className="container-fluid Card mb-3 " style={{ backgroundColor: "#F6F2ED", width: "fit-content" }}>
                <Row>
                    {Product.map((item) => (
                        <Col className="dflex JCCenter alignitems Patners-Implementation" ><img src={item.img} className="w-50" /> </Col>
                    ))}

                </Row>
            </div>

            <span>Knowledge Partner</span>
            <div className="container-fluid Card" style={{ backgroundColor: "#F6F2ED", width: "fit-content" }}>
                <Row>
                    {Knowledge.map((item, index) => (
                        <Col className=" alignitems Patners-Knowledge" >
                            <div className="CPointer dflex JCCenter" > <img src={item.img} className="w-75" /></div></Col>
                        // onClick={() => OPenLinkKnowledge(index)}
                    ))}

                </Row>
            </div>

        </div>
    )
};
export default Patners;